/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { AppBar, Grid, Link, Theme, Container } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { NavHashLink } from 'react-router-hash-link'
import clsx from 'clsx'
import { MyLink } from '../my-link'
import { useReduxSelector } from '../../../hooks'
import { withPlanner, WithPlannerProps } from '../../hoc'
import { str } from '../../../utils'
import { ProgressBar } from '../../progress-bar'
import { StopAction } from '../../stop-action'

type MenuItem = {
  title: string
  key: string
  url?: string
  hash: boolean
  target: '_self' | '_blank'
}

const { REACT_APP_RULES_URL: RULES } = process.env

const menu: MenuItem[] = [
  {
    title: 'Новости',
    key: 'news',
    hash: true,
    target: '_self',
  },
  // {
  //   title: 'География кубка',
  //   key: 'maps',
  //   hash: true,
  //   target: '_self',
  // },
  {
    title: 'Турнирная таблица',
    key: 'tourtable',
    hash: true,
    target: '_self',
  },
]

export const DesktopMenu: React.FC<WithPlannerProps> = withPlanner(({ planner }): JSX.Element => {
  const classes = useStyles()

  const { REACT_APP_URL: URL, REACT_APP_PORTAL_URL: PORTAL } = process.env

  const { auth } = useReduxSelector((state) => state.auth)
  const { data: constants } = useReduxSelector((state) => state.constants)

  const onScroll = () => {
    window.scrollTo(0, 0)
  }

  return (
    <>
      <AppBar position="fixed">
        <ProgressBar height={2} />
      </AppBar>

      <AppBar position="relative">
        <Container className={classes.container}>
          <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
            <Grid item xs={auth ? 12 : 10}>
              <Grid
                container
                alignItems="center"
                style={{ height: '100%' }}
                justifyContent={auth ? 'space-between' : 'space-evenly'}
              >
                <Grid item xs="auto">
                  <Link
                    to="/"
                    component={MyLink}
                    onClick={() => onScroll()}
                    className={clsx(classes.link, classes.selectLink)}
                  >
                    Pro кубок
                  </Link>
                </Grid>

                {auth &&
                  menu.map((i, k) => {
                    const { key, title, hash } = i
                    return (
                      <Grid key={k + key} item xs="auto">
                        <NavHashLink to={`/#${key}`} smooth className={classes.link}>
                          {str.normalize(title)}
                        </NavHashLink>
                      </Grid>
                    )
                  })}

                {auth && (
                  <>
                    <Grid item xs="auto">
                      <Link
                        component={MyLink}
                        to="/media"
                        onClick={() => onScroll()}
                        className={clsx(classes.link, classes.selectLink)}
                      >
                        Кубок в объективе
                      </Link>
                    </Grid>
                    <Grid item xs="auto">
                      <Link
                        component={MyLink}
                        onClick={() => onScroll()}
                        className={clsx(classes.link, classes.selectLink)}
                        to={window.location.href === `${URL}/lk?checklist` ? '/lk?checklist' : '/lk'}
                      >
                        Личный кабинет
                      </Link>
                    </Grid>
                    <Grid item xs="auto">
                      <Link component={MyLink} to="/logout" className={classes.signin}>
                        Вернуться на портал
                      </Link>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </AppBar>
    </>
  )
})

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  container: {
    width: '100%',
    maxWidth: '1300px!important',
    height: 90,
    [down('lg')]: {
      height: 80,
    },
  },
  link: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none!important',
    textTransform: 'uppercase',
    fontSize: '16px!important',
    fontWeight: 600,
    color: '#6C6C6C!important',
    position: 'relative',
    '&:hover': {
      color: palette.text.primary,
      textDecoration: 'none',
    },
    [down('lg')]: {
      fontSize: '14px!important',
    },
    [down(1100)]: {
      fontSize: '13px!important',
    },
  },
  selectLink: {
    '&.active': {
      color: `${palette.primary.contrastText}!important`,
      '&:after': {
        position: 'absolute',
        width: '100%',
        content: "''",
        marginTop: 2,
        display: 'block',
        border: `1px solid ${palette.error.main}`,
      },
    },
  },
  signin: {
    '-webkit-tap-highlight-color': 'transparent',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none!important',
    textTransform: 'uppercase',
    fontSize: '14px!important',
    fontWeight: 600,
    color: '#6C6C6C!important',
    position: 'relative',
    '&:hover': {
      color: palette.text.primary,
      textDecoration: 'none',
    },
    [down('lg')]: {
      fontSize: '12px!important',
    },
    [down(1100)]: {
      fontSize: '11px!important',
    },
  },
}))
